import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState, defaultState } from "./state";
import { updateStorage, getStorage } from "../../utilities/setting";
import _ from "lodash";

const createUserObj = (state: typeof initialState) => ({
  saveLocal: state.saveLocal,
  storeKey: state.storeKey,
  user: _.cloneDeep(state.user),
});

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<Record<string, unknown>>) => {
      const json = getStorage(state.storeKey as string);
      if (json === "none") state.saveLocal = "none";
      if (json !== null && json !== "none") {
        state.saveLocal = (json as typeof initialState).saveLocal;
        state.user = { userData: action.payload as Record<string, string> };
      }
      updateStorage(state.saveLocal as string, state.storeKey as string, createUserObj(state));
    },
    reset_state: (state, _action: PayloadAction<unknown>) => {
      state.user = defaultState.user;
      updateStorage(state.saveLocal as string, state.storeKey as string, createUserObj(state));
    },
    saveLocal: (state, action: PayloadAction<string>) => {
      if (typeof action.payload !== typeof undefined) {
        state.saveLocal = action.payload;
      }
      const userObj = {
        saveLocal: state.saveLocal,
        storeKey: state.storeKey,
        user: _.cloneDeep(state.user),
      };
      updateStorage(state.saveLocal as string, state.storeKey as string, userObj);
    },
  },
});

export default userSlice.reducer;
